import { useReactiveVar } from "@apollo/client";
import * as Styles from "./style";
import { Accordion } from "~/components/blocks/layout/global-navi/mobile/left/dmm-service/accordion";
import { AccordionContent } from "~/components/blocks/layout/global-navi/mobile/left/dmm-service/accordion/content";
import { LinkListItem } from "~/components/blocks/layout/global-navi/mobile/left/dmm-service/link-item";
import { dmmServiceListDataVar } from "~/components/blocks/layout/store";

export const MenuList = () => {
  const dmmServiceListData = useReactiveVar(dmmServiceListDataVar);

  return (
    <Styles.ULContainer>
      {dmmServiceListData.map((service, idx) => {
        return service.floors.length > 0 ? (
          <Accordion
            key={service.name}
            title={service.name}
            src={service.src}
            name={service.name}
            defaultIsOpen={idx === 0}
            viaViewRank={idx + 1}
            viaTargetId={service.data_link}
            isNew={service.isNew}
          >
            {service.floors.map(
              ({ name, href, src, data_link, isNew }, idx) =>
                // TODO:(kato) APIの修正があり次第削除
                // MEMO: グラビア要素を除去
                data_link !== "dmmtv_gravure" && (
                  <AccordionContent
                    key={name}
                    name={name}
                    href={href}
                    src={src}
                    parentName={service.name}
                    viaViewRank={idx + 1}
                    viaTargetId={data_link}
                    isNew={isNew}
                  />
                )
            )}
          </Accordion>
        ) : (
          <LinkListItem
            key={service.name}
            href={service.href}
            name={service.name}
            image={service.src}
            viaViewRank={idx + 1}
            viaTargetId={service.data_link}
            isNew={service.isNew}
          />
        );
      })}
    </Styles.ULContainer>
  );
};
